import { useCallback } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useIsGameCurrencyChangeEnabled from '~/client/hooks/feature/inGameCurrency/useIsGameCurrencyChangeEnabled';
import useToast from '~/client/hooks/useToast';
import { useSetInGameCurrencyMutation } from './SetInGameCurrencyMutation.generated';

const useSetInGameCurrency = () => {
  const { inGameCurrencyList, setInGameCurrency: setContextInGameCurrency } =
    useGameContext();
  const { showToast } = useToast();
  const isGameCurrencyChangeEnabled = useIsGameCurrencyChangeEnabled();
  const [setInGameCurrencyMutation] = useSetInGameCurrencyMutation();

  const setInGameCurrency = useCallback(
    async (currency = '') => {
      if (!isGameCurrencyChangeEnabled) {
        return;
      }
      const preferredInGameCurrency = inGameCurrencyList?.includes(currency)
        ? currency
        : undefined;
      const payload = await setInGameCurrencyMutation({
        variables: { preferredInGameCurrency },
      });
      if (payload.errors) {
        showToast({
          timeout: 5000,
          variant: 'error',
          message: 'general.error_set_in_game_currency',
        });
      } else {
        setContextInGameCurrency?.(preferredInGameCurrency ?? null);
      }
    },
    [
      inGameCurrencyList,
      isGameCurrencyChangeEnabled,
      setContextInGameCurrency,
      setInGameCurrencyMutation,
      showToast,
    ],
  );

  return { setInGameCurrency };
};

export default useSetInGameCurrency;
